import React from 'react'
import { useSelector } from 'react-redux'
import {
    mdiCheckCircleOutline,
    mdiAlertCircleOutline,
    mdiCloseCircleOutline,
    mdiPower
} from '@mdi/js'
import Icon from '@mdi/react'
import { Tooltip } from '..'
// import { getMainColor, hasNoDevices } from '../../../../../../../'
import { makeStyles } from '@material-ui/core'
import {
    getLocationDotColor,
    locationHasNoDevices
} from '../../../../locations/utils/get-marker-icon'

export const LocationDevicesDot = ({ location }) => {
    const { theme, locale } = useSelector(state => state.main)
    const color = getLocationDotColor(location, theme)
    const hasNoDevicesBool = locationHasNoDevices(location)
    const classes = useStyles()

    const renderContent = hasNoDevicesBool => {
        if (hasNoDevicesBool) {
            return (
                <div>
                    <span>{locale.locations.devices}: 0</span>
                </div>
            )
        }

        return (
            <div>
                <span>{locale.locations.devices}</span>
                <div className={classes.root}>
                    <div className={classes.row}>
                        <Icon
                            path={mdiCheckCircleOutline}
                            size={1}
                            color={theme.active}
                        />
                        <span style={{ color: theme.active, marginLeft: 4 }}>
                            {location.devices_active}
                        </span>
                    </div>
                    <div className={classes.row}>
                        <Icon
                            path={mdiCloseCircleOutline}
                            size={1}
                            color={theme.error}
                        />
                        <span style={{ color: theme.error, marginLeft: 4 }}>
                            {location.devices_critical}
                        </span>
                    </div>
                    <div className={classes.row}>
                        <Icon
                            path={mdiAlertCircleOutline}
                            size={1}
                            color={theme.warning}
                        />
                        <span style={{ color: theme.warning, marginLeft: 4 }}>
                            {location.devices_warning}
                        </span>
                    </div>
                    <div className={classes.row}>
                        <Icon
                            path={mdiPower}
                            size={1}
                            color={theme.secondary}
                        />
                        <span style={{ color: theme.secondary, marginLeft: 4 }}>
                            {location.devices_inactive}
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Tooltip
            hover
            text={renderContent(hasNoDevicesBool)}
            tooltipClass={classes.tooltipClass}
        >
            <div
                style={{
                    width: 12,
                    height: 12,
                    backgroundColor: hasNoDevicesBool ? undefined : color,
                    borderRadius: 12,
                    border: hasNoDevicesBool ? `2px solid ${color}` : undefined
                }}
            />
        </Tooltip>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: 8,
        display: 'flex'
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 16
    },
    tooltipClass: {
        backgroundColor: theme.primary,
        opacity: 1
    }
}))
